import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { Close } from 'grommet-icons';

import { Button, Box, Layer } from 'components/Wrapped';

const WrappedModal = ({
  children,
  position,
  toggleModal,
  trigger,
  show,
  width = 'medium',
  heading,
  pad = 'large',
  customize = {},
  ...rest
}) => {
  const [isVisible, setShow] = React.useState();

  const toggle = () => () => {
    if (!trigger && toggleModal) {
      toggleModal();
    }
    setShow(!isVisible);
  };

  React.useEffect(() => {
    if (!trigger) {
      setShow(show);
    }
  }, [show, trigger]);

  return (
    <Fragment>
      {trigger &&
        React.cloneElement(trigger, {
          onClick: toggle(),
        })}
      {isVisible && (
        <Layer
          {...rest}
          responsive={false}
          position={position}
          onClickOutside={toggle()}
          onEsc={toggle()}
          style={{ background: 'transparent' }}
        >
          <Box
            background="#000D14"
            border={{
              color: '#38444A',
              size: '1px',
              style: 'solid',
              side: 'all',
            }}
            pad="none"
            round="16px"
            width={width}
          >
            {/* <Box
              background="background-3"
              pad="small"
              align="center"
              justify={heading ? 'between' : 'end'}
              round={false}
              direction="row"
            >
              {heading && <Text size="medium">{heading}</Text>}
            </Box> */}
            <Button
              plain={true}
              icon={<Close />}
              style={{
                position: 'absolute',
                top: '30px',
                right: '18px',
                padding: 0,
              }}
              onClick={toggle()}
            />
            <Box pad={pad} style={customize}>
              {children}
            </Box>
          </Box>
        </Layer>
      )}
    </Fragment>
  );
};

WrappedModal.propTypes = {
  children: PropTypes.node,
  trigger: PropTypes.node,
  position: PropTypes.string.isRequired,
};

WrappedModal.defaultProps = {
  position: 'center',
};

export default WrappedModal;
